import React from 'react';

const ValidationContext = React.createContext({});

export const ValidationProvider = ValidationContext.Provider;

export default ValidationContext
